<script setup lang="ts">
import { formatMoney, type Money } from '@taler/domain'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/app/components/MoneyAmount.vue'
import { useCountUp } from '../internal/count-up.ts'
import { usePrefersReducedMotion } from '../internal/reduced-motion.ts'

const props = defineProps<{ value: Money | undefined; label: string }>()
const { locale } = useI18n()

const reducedMotion = usePrefersReducedMotion()
const countUp = useCountUp({ value: () => props.value, reducedMotion: () => reducedMotion.value })

const localeCode = computed(() => locale.value as 'en' | 'hu')
const finalText = computed(() =>
  props.value === undefined ? undefined : formatMoney(props.value, { locale: localeCode.value }),
)
// Reserved from the true final value, so the growing digit count never reflows the row
// while the count-up is in flight.
const reservedWidth = computed(() =>
  finalText.value === undefined ? undefined : `${finalText.value.length}ch`,
)
</script>

<template>
  <div v-if="finalText && countUp.displayed.value" id="dashboard-net-worth" class="flex flex-col gap-1">
    <p class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">{{ label }}</p>
    <MoneyAmount
      aria-hidden="true"
      :value="countUp.displayed.value"
      size="hero"
      :style="{ minWidth: reservedWidth }"
    />
    <p class="sr-only">{{ label }}: {{ finalText }}</p>
  </div>
</template>
